import { useMutation } from 'react-query';
import api from 'src/services/api';

export const updateStatusSettings = ({
  customerEnvId,
  minDeviceAgeDays,
  minCleanCheckInStreak,
  maxLastCheckInAgeDays,
  minIntervalBetweenCheckInHours,
  healthyDeviceThresholdDays,
  autoArchiveThresholdDays,
}) =>
  api.put(`customerEnvironment/${customerEnvId}/statusSettings`, {
    minDeviceAgeDays,
    minCleanCheckInStreak,
    maxLastCheckInAgeDays,
    minIntervalBetweenCheckInHours,
    healthyDeviceThresholdDays,
    autoArchiveThresholdDays,
  });

export const useUpdateStatusSettings = () => useMutation(updateStatusSettings);
